const CONTEXT_ID = 'UPLOAD_TESTCASES_FORM';

export default CONTEXT_ID;
